// extracted by mini-css-extract-plugin
module.exports = {"baseColor":"#ff0059","baseColorDisabled":"rgba(255,0,89,.66)","blueAccent":"#44a1ff","greenAccent":"#00e676","darkBackgroundColor":"#111827","darkBorderColor":"rgba(17,24,39,.33)"};